import { FC, useState } from 'react';
import { Button, ButtonProps } from '@mui/material';

import { ContactRequestModal } from '../Modal';

export const RecruitingServicesButton: FC<ButtonProps> = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setOpen(true)} {...props}>
        Recruiting Services
      </Button>
      <ContactRequestModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};
